import {
  extractSwitchTenantId,
  urlWithoutSwitchTenantParam,
} from 'scaleflow/utils/switch-tenant-url';

// Must run before the router's first transition: `ApplicationRoute#beforeModel`
// loads the organisation for whatever tenant is already in `sessionStorage`,
// so a route-level handler for `?switchTenant=` would already be too late.
export function initialize() {
  const tenantId = extractSwitchTenantId(window.location.search);
  if (!tenantId) return;

  window.sessionStorage.setItem('tenant', tenantId);
  window.history.replaceState(
    null,
    '',
    urlWithoutSwitchTenantParam(window.location.href),
  );
}

export default {
  initialize,
};
